import { css } from 'styled-components'

export const fonts = css`
  html {
    font-family: 'Manrope', Helvetica, Arial, sans-serif;
  }
`
